import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { Subject } from "rxjs";

@Component({
  selector: "app-marquee",
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: "./marquee.component.html",
  styleUrl: "./marquee.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarqueeComponent implements OnChanges, OnDestroy {
  @Input() items: (string | { icon: string; text: string })[] = [];
  extendedItems: (string | { icon: string; text: string })[] = [];
  duration: number = 40;

  public destroy$: Subject<any> = new Subject();

  constructor(private el: ElementRef, private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["items"] && this.items.length > 0) {
      this.extendedItems = [...this.items, ...this.items];

      // Calculate speed and set duration
      setTimeout(() => {
        const content = this.el.nativeElement.querySelector(".marquee-content");
        const container =
          this.el.nativeElement.querySelector(".marquee-container");

        if (content && container) {
          const contentWidth = content.scrollWidth;
          const containerWidth = container.clientWidth;

          const speed = Math.max(20, (contentWidth / containerWidth) * 5);

          this.duration = speed;

          // Manually trigger change detection
          this.cdr.detectChanges();
        }
      }, 0);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
